import { ReportBuilderWrapper } from '../../components'

export default function ReportBuilderPage() {
  return (
    <div className="spacer-md">
      <ReportBuilderWrapper />
    </div>
  )
}
